import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import { retry } from '../../utils/PromiseRetry';
import { PublicRoute } from './routesConfig';

const Home = lazy(() => retry(() => import('../components/Home/index')));
const PlanDetailsForm = lazy(() => retry(() => import('../components/PlanDetailsForm')));
const ThankYouPage = lazy(() => retry(() => import('../components/ThankYouPage')));

const router = createBrowserRouter([
    {
        path: '/',
        errorElement: <Navigate to={"/"} />,
        children: [
            { path: "/", element: <PublicRoute element={<Home />} /> },
            { path: "plan-details", element: <PublicRoute element={<PlanDetailsForm />} /> },
            { path: "thank-you", element: <PublicRoute element={<ThankYouPage />} /> },
        ],
    },
]);


const AppRouter = () => {
    return (
        <Suspense fallback={
            <span style={{ textAlign: "center", display: "block" }}>
                <div style={{ display: "inline-block", marginTop: "300px" }}>
                    <ClipLoader
                        color={"#41d4ce"}
                        loading={true}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            </span>}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default AppRouter;
